<template>
  <nav class="navbar navbar-expand-lg primary-nav">
    <div class="container mm-scroll">
      <a class="brand" href="/ ">
        <img src="../assets/images/logo-aptanutricia.png" alt="AptaNutricia Logo" style="    width: 168px;
    height: 94px;">
      </a>
      <div id="menuToggle" class="nav-container">
        <div class="hamburger hamburger--spin " v-on:click="mobileMenu()">
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>
      <div class="nav-and-buttons hide" id="menu-list">
        <div class="center-menu">
          <ul class="navbar-nav nav" id="menu">
            <a href="https://www.aptanutricia.ro/sunt-insarcinata">
            </a>
            <li v-on:click="dropdown1()" class="nav-item dropdown"><a href="https://www.aptanutricia.ro/sunt-insarcinata">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/sunt-insarcinata">
              </a><a class="nav-link nav-dropdown dropdown-toggle" href="https://www.aptanutricia.ro/sunt-insarcinata"
              >
                Însărcinată</a>
                <i class="fa fa-chevron-down fa-close">
                  <img src="../assets/images/down-menu.png" alt="/">
                </i>
              </div>
              <div class="dropdown-content" id="content1">
                <div class="dropdown-menu" id="dropdownMenu1">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">ARTICOLE</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/sarcina-pe-saptamani">Sarcina pe săptămâni</a></li>
                        <li><a href="https://www.aptanutricia.ro/sanatatea-in-sarcina">Sănătatea în sarcină</a></li>
                        <li><a href="https://www.aptanutricia.ro/alimentatia-in-sarcina">Alimentația în sarcină</a></li>
                        <li><a href="https://www.aptanutricia.ro/ingrijirea-in-sarcina">Îngrijirea în sarcină</a></li>
                        <li><a href="https://www.aptanutricia.ro/pregatirea-pentru-nastere">Pregătirea pentru naștere</a></li>
                        <li><a href="https://www.aptanutricia.ro/recuperarea-dupa-nastere">Recuperarea după naștere</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">APLICAȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/calculator-sarcina">Calculator de sarcină</a></li>
                      </ul>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">ÎNTREABĂ EXPERȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii">Întrebări frecvente în sarcină</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/cum-alaptez">
            </a>
            <li class="nav-item dropdown" v-on:click="dropdown2()"><a href="https://www.aptanutricia.ro/cum-alaptez">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/cum-alaptez">
              </a><a class="nav-link nav-dropdown dropdown-toggle" role="&quot;button&quot;"
                     id="&quot;dropdownMenu1&quot;" aria-haspopup="&quot;true&quot;" aria-expanded="&quot;false&quot;"
                     data-toggle="&quot;dropdown&quot;" href="https://www.aptanutricia.ro/cum-alaptez"
              >
                Cum alăptez</a>
                <i class="fa fa-chevron-down fa-close"> <img src="../assets/images/down-menu.png" alt="/"></i>
              </div>
              <div class="dropdown-content" id="content2">
                <div class="dropdown-menu middle" id="dropdownMenu2">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <p class="dropdown-item mb-0">ARTICOLE</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/beneficiile-alaptarii">Beneficiile alăptării</a></li>
                        <li><a href="https://www.aptanutricia.ro/alimentatia-in-alaptare">Alimentația în alăptare</a></li>
                        <li><a href="https://www.aptanutricia.ro/probleme-in-alaptare">Probleme în alăptare</a></li>
                        <li><a href="https://www.aptanutricia.ro/mituri-despre-alaptare">Mituri despre alăptare</a></li>
                      </ul>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <p class="dropdown-item mb-0">ÎNTREABĂ EXPERȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii/alaptare">Întrebări frecvente în alăptare</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/bebe-0-12-luni">
            </a>
            <li class="nav-item dropdown" v-on:click="dropdown3"><a href="https://www.aptanutricia.ro/bebe-0-12-luni">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/bebe-0-12-luni">
              </a><a class="nav-link nav-dropdown dropdown-toggle" role="&quot;button&quot;"
                     id="&quot;dropdownMenu2&quot;" aria-haspopup="&quot;true&quot;" aria-expanded="&quot;false&quot;"
                     data-toggle="&quot;dropdown&quot;" href="https://www.aptanutricia.ro/bebe-0-12-luni">
                Bebe 0 - 12 luni</a>
                <i class="fa fa-chevron-down fa-close"> <img src="../assets/images/down-menu.png" alt="/"></i>
              </div>
              <div class="dropdown-content" id="content3">
                <div class="dropdown-menu middle" id="dropdownMenu3">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <p class="dropdown-item mb-0">ARTICOLE</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/dezvoltarea-bebelusului">Dezvoltarea bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/sanatatea-bebelusului">Sănătatea bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/imunitatea-bebelusului">Imunitatea bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/alimentatia-bebelusului">Alimentatia bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/ingrijirea-bebelusului">Îngrijirea bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/somnul-bebelusului">Somnul bebelușului</a></li>
                      </ul>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">ÎNTREABĂ EXPERȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii/sarcina">Întrebări frecvente despre bebe</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/copil-1-an">
            </a>
            <li class="nav-item dropdown" v-on:click="dropdown4"><a href="https://www.aptanutricia.ro/copil-1-an">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/copil-1-an">
              </a><a class="nav-link nav-dropdown dropdown-toggle" role="&quot;button&quot;"
                     id="&quot;dropdownMenu3&quot;" aria-haspopup="&quot;true&quot;" aria-expanded="&quot;false&quot;"
                     data-toggle="&quot;dropdown&quot;" href="https://www.aptanutricia.ro/copil-1-an">
                Copil 1 an +</a>
                <i class="fa fa-chevron-down fa-close"> <img src="../assets/images/down-menu.png" alt="/"></i>
              </div>
              <div class="dropdown-content" id="content4">
                <div class="dropdown-menu " id="dropdownMenu4">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">ARTICOLE</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/dezvoltarea-copilului">Dezvoltarea copilului</a></li>
                        <li><a href="https://www.aptanutricia.ro/sanatatea-copilului">Sănătatea copilului</a></li>
                        <li><a href="https://www.aptanutricia.ro/imunitatea-copilului">Imunitatea copilului</a></li>
                        <li><a href="https://www.aptanutricia.ro/alimentatia-copilului">Alimentatia copilului</a></li>
                        <li><a href="https://www.aptanutricia.ro/ingrijirea-copilului">Îngrijirea copilului</a></li>
                        <li><a href="https://www.aptanutricia.ro/activitati">Activități</a></li>
                      </ul>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">APLICAȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/academia-junior">Academia AptaJunior</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <p class="dropdown-item mb-0">ÎNTREABĂ EXPERȚII</p>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii/sarcina">Întrebări frecvente despre imunitate</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/stiinta-nutricia">
            </a>
            <li class="nav-item dropdown" v-on:click="dropdown5"><a href="https://www.aptanutricia.ro/stiinta-nutricia">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/stiinta-nutricia">
              </a><a class="nav-link nav-dropdown dropdown-toggle" role="&quot;button&quot;"
                     id="&quot;dropdownMenu4&quot;" aria-haspopup="&quot;true&quot;" aria-expanded="&quot;false&quot;"
                     data-toggle="&quot;dropdown&quot;" href="https://www.aptanutricia.ro/stiinta-nutricia">
                Știința Nutricia</a>
                <i class="fa fa-chevron-down fa-close"> <img src="../assets/images/down-menu.png" alt="/"></i>
              </div>
              <div class="dropdown-content" id="content5">
                <div class="dropdown-menu simple" id="dropdownMenu5">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a class="dropdown-item mb-0" href="https://www.aptanutricia.ro/stiinta-nutricia">ȘTIINȚA NUTRICIA</a>
                      <a class="dropdown-item mb-0" href="https://www.aptanutricia.ro/formule-aptanutricia">FORMULE DE LAPTE</a>
                      <a class="dropdown-item mb-0" href="https://www.aptanutricia.ro/totul-despre-imunitate">Totul despre imunitate</a>
                      <a class="dropdown-item mb-0" href="https://www.aptanutricia.ro/sams">Asociația SAMAS</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/intreaba-expertii">
            </a>
            <li class="nav-item dropdown" v-on:click="dropdown6"><a href="https://www.aptanutricia.ro/intreaba-expertii">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/intreaba-expertii">
              </a><a class="nav-link nav-dropdown dropdown-toggle" role="&quot;button&quot;"
                     id="&quot;dropdownMenu5&quot;" aria-haspopup="&quot;true&quot;" aria-expanded="&quot;false&quot;"
                     data-toggle="&quot;dropdown&quot;" href="https://www.aptanutricia.ro/intreaba-expertii">
                Experții Nutricia </a>
                <i class="fa fa-chevron-down fa-close"> <img src="../assets/images/down-menu.png" alt="/"></i>
              </div>
              <div class="dropdown-content" id="content6">
                <div class="dropdown-menu simple" id="dropdownMenu6">
                  <div class="triangle">
                    <div class="arrow-up"></div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a class="dropdown-item mb-0" href="">ÎNTREABĂ EXPERȚII</a>
                      <ul class="submenu-list">
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=139">Sarcină</a></li>
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=140">Dezvoltarea Bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=141">Îngrijirea Bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=142">Nutriția Bebelușului</a></li>
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=143">Sănătate</a></li>
                        <li><a href="https://www.aptanutricia.ro/intreaba-expertii?categoryId=144">Alăptare</a></li>
                      </ul>
                      <a class="dropdown-item mb-0" href="https://www.aptanutricia.ro/prezentare-experti">PREZENTARE EXPERȚI</a>
                      <ul class="submenu-list"></ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <a href="https://www.aptanutricia.ro/beneficii">
            </a>
            <li class="nav-item "><a href="https://www.aptanutricia.ro/beneficii">
            </a>
              <div class="d-flex dropdown-parent"><a href="https://www.aptanutricia.ro/beneficii">
              </a><a class="nav-link " href="https://www.aptanutricia.ro/beneficii">
                Beneficiile Clubului</a>
              </div>
            </li>

          </ul>
          <div class="buttons-mobile-acc">
            <a href="https://www.aptanutricia.ro/inregistrare" class="nav-user new-cont">Creează
              cont</a>
            <a href="https://www.aptanutricia.ro/autentificare" class="nav-user cont">Intră în
              cont</a>
          </div>
          <div class="menu-buttons desktop">
            <div class="d-flex align-center-mobile">
              <!--
              <a href="#" class="nav-search hvr-grow" data-toggle="modal" data-target="#searchModal">
                <img src="/themes/custom/aptanutricia/images/search.svg" alt="">
              </a>
              -->
              <a href="https://www.aptanutricia.ro/autentificare" class="nav-user hvr-grow">
                <img src="../assets/images/users.png" alt="Autentificare" style="width: 20px; height: 20px">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-buttons mobile">
        <!--
        <a href="#" class="nav-search nav-search-mobile-h" data-toggle="modal" data-target="#searchModal">
          <img src="/themes/custom/aptanutricia/images/search.svg" alt="">
        </a>
        -->
        <div class="d-flex align-center-mobile">
          <a href="https://www.aptanutricia.ro/autentificare"
             class="nav-user nav-user-mobile hvr-grow" style="left: 20px;">
            <img src="../assets/images/users.png" alt="/" style="width: 20px; height: 20px">
          </a>
        </div>
      </div>
    </div>
    <div class="notification-menu-sidebar">
      <ul>
        <li id="closeNotificationsMenu" class="hvr-shrink">
          <img src="/themes/custom/aptanutricia/images/account/bell.svg" alt="">
        </li>
        <li class="notification-text notif-1">
          <a href="https://www.aptanutricia.ro/node/391" class="pink-n hvr-forward">
            <h6>Articol nou - </h6>
            <p>Articol | </p>
          </a>
          <div class="delete-notification">
            <form class="delete-notifications-form-1" data-drupal-selector="delete-notifications-form-1"
                  action="https://www.aptanutricia.ro/sunt-insarcinata" method="post" id="delete-notifications-form-1"
                  accept-charset="UTF-8">
              <input id="submit-1" class="delete-notification-button button js-form-submit form-submit"
                     data-drupal-selector="edit-submit" type="submit" name="op" value="">
              <input autocomplete="off" data-drupal-selector="form-tbvlumcmwrfpuffp1ijpro2ewb-94dw7foxxkdsndaa"
                     type="hidden" name="form_build_id" value="form-tbvlUmcMwRFPUfFP1ijPrO2eWB-94dW7foXXKdsndAA">
              <input data-drupal-selector="edit-delete-notifications-form-1" type="hidden" name="form_id"
                     value="delete_notifications_form_1">

            </form>

          </div>

        </li>
        <form class="notifications-form-1" data-drupal-selector="notifications-form-1"
              action="https://www.aptanutricia.ro/sunt-insarcinata" method="post" id="notifications-form-1"
              accept-charset="UTF-8">
          <input id="submit-1" class="d-none button js-form-submit form-submit" data-drupal-selector="edit-submit"
                 type="submit" name="op" value="Trimite">
          <input autocomplete="off" data-drupal-selector="form-uab5khmmdv-uvarjoc1tknd9heewpxafvml4khmwk3k"
                 type="hidden" name="form_build_id" value="form-uaB5KhMmdv_UvaRjoc1tKND9hEEWPxafvMl4khMWK3k">
          <input data-drupal-selector="edit-notifications-form-1" type="hidden" name="form_id"
                 value="notifications_form_1">

        </form>


      </ul>
    </div>


  </nav>
</template>
<script>
import logo from '../assets/images/logo-4@2x.png'
import arrow from '../assets/images/left-arrow.svg'

export default {
  name: 'Menu',
  data() {
    return {
      logo: logo,
      arrow: arrow,
      val_active: false
    }
  },
  methods: {
    goTo() {
      window.fbq('track', 'Intreaba-Expertii');
      window.gtag('event', 'sent', {'event_category': 'buton-intreaba-expertii'});
      window.open("https://www.aptanutricia.ro/descopera-stiinta-nutricia/mamicile-intreaba", '_blank');
    },
    mobileMenu() {

      let menuList = document.querySelector('#menu-list')
      if (menuList.style.display == 'none') {
        menuList.style.display = 'initial'
      } else {
        menuList.style.display = 'none'
      }

    },
    dropdown1() {

      document.querySelector("#content1").classList.toggle('flex')
      document.querySelector('#dropdownMenu1').classList.toggle('flex')

    },
    dropdown2() {

      document.querySelector("#content2").classList.toggle('flex')
      document.querySelector('#dropdownMenu2').classList.toggle('flex')

    },
    dropdown3() {

      document.querySelector("#content3").classList.toggle('flex')
      document.querySelector('#dropdownMenu3').classList.toggle('flex')

    },
    dropdown4() {

      document.querySelector("#content4").classList.toggle('flex')
      document.querySelector('#dropdownMenu4').classList.toggle('flex')

    },
    dropdown5() {

      document.querySelector("#content5").classList.toggle('flex')
      document.querySelector('#dropdownMenu5').classList.toggle('flex')

    },
    dropdown6() {

      document.querySelector("#content6").classList.toggle('flex')
      document.querySelector('#dropdownMenu6').classList.toggle('flex')

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dropdown p,
.dropdown ul {
  padding-left: 0;
}

nav {
  z-index: 200;
}

.flex {
  display: block !important;
}

.navbar-collapse {
  justify-content: space-between;
}

nav .nav-link:hover {
  color: #029FE3;
}


.brand {
  position: relative;
  top: -4px;
}

.navbar .brand img {
  height: 100px;
  margin-left: -45px;
}

.dropdown-item {
  text-transform: uppercase;
  color: #919191;
  font-weight: 500;
  padding-bottom: 15px;
  letter-spacing: 0.8px;
  cursor: context-menu;
}

.navbar-nav .nav-link {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.notifications-count {
  position: relative;
  top: -10px;
  left: -15px;
  font-size: 12px;
  font-weight: 700;
  background: #ffffffb8;
  padding: 1px 5px;
  border-radius: 50%;
}

.submenu-list li, .dropdown-item {
  font-size: 14px;
}

.submenu-list li {
  list-style: none;
}

ul.submenu-list li {
  color: black;
  font-weight: 600;
  margin-bottom: 10px;
}

ul.submenu-list li a {
  color: black;
}

.dropdown-item:focus, .dropdown-item:hover {
  color: grey;
  text-decoration: none;
  background-color: transparent;
}

.dropdown-content {
  padding-top: 35px;
  display: none;

}

.dropdown-content .dropdown-menu {
  display: block;
  transform: translate3d(0px, 70px, 0px);
  left: -50px;
  top: 8px;
  will-change: transform;
  width: 760px;
  padding: 35px 35px;
  border: 0;
  -webkit-box-shadow: 0 4px 15px 5px rgba(142, 142, 142, 0.99);
  box-shadow: 0 4px 15px 5px rgba(142, 142, 142, 0.42);
}

.dropdown-parent {
  height: 66px;
  position: relative;
  top: 20px;
}

.menu-buttons {
  display: flex;
  align-items: center;
}

.navbar .mm-scroll .nav-and-buttons .center-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.nav-link {
  color: #17479E;
  font-size: 12px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

.nav-link.active {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 12px;
}

.dropdown:hover .dropdown-content, .dropdown-content:hover {
  display: block;
  position: relative;
}

.primary-nav {
  background: #abcae9;
  box-shadow: 0 4px 15px 5px rgba(142, 142, 142, 0.42);
}

.nav-item {
  cursor: pointer;
  margin-right: 15px;
  display: flex;
}

a.dropdown-item {
  cursor: pointer;
}

.logo img {
  margin-bottom: 35px;
}

.dropdown-toggle::after {
  display: none;

}

.menu-buttons.mobile {
  display: none;
}

.fa.fa-chevron-down {
  height: 12px;
  width: 10px;
  position: relative;
  top: 11px;
  left: 0;
  font-size: 11px;
  color: #17479e;
  margin-left: 2px;
  transform: rotate(0deg);
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-item.dropdown:hover .fa.fa-chevron-down {
  transform: rotate(180deg);
  color: #029fe3;
}

.nav-item.dropdown:hover .fa.fa-chevron-down, .nav-item.dropdown .fa.fa-chevron-down {
  transition: 0.3s all ease;
}

/*Triangle box menu*/
.triangle {
  position: relative;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid white;
  position: absolute;
  top: -45px;
  left: 45px;
}

.buttons-mobile-acc {
  display: none;
}

.notification-menu-sidebar {
  position: fixed;
  right: -350px;
  height: 100%;
  z-index: 999;
  top: 0;
  overflow-y: auto;
  width: 350px;
  transition: 0.4s all ease;
}

.notification-menu-sidebar ul {
  background: #333333;
  margin: 0;
  padding: 0 30px 10px;
  min-height: 100vh;
}

#closeNotificationsMenu {
  cursor: pointer;
}

.notification-menu-sidebar img {
  padding-top: 15px;
  padding-bottom: 30px;
}

.notification-menu-sidebar p {
  color: #919191;
  font-size: 12px;
}

.notification-menu-sidebar h6 {
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  width: 100%;
}

.notification-text {
  display: flex;
  justify-content: space-between;
}

.delete-notification {
  position: relative;
  z-index: 99999;
  cursor: pointer;
}

.notification-text:hover .delete-notification img {
  display: block;
  transition: 0.3s all ease;
}

.notification-menu-sidebar a.white-n h6 {
  color: #fff;
}

.notification-menu-sidebar a.pink-n h6 {
  color: #FFBDBA;
}

/*End*/

#menuToggle input.hamburger-menu, #menuToggle span {
  display: none;
}

.nav-and-buttons {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.dropdown-content .dropdown-menu.simple {
  width: 320px;
}

.dropdown-content .dropdown-menu.middle {
  width: 600px;
}

.nav-search-mobile, .nav-user-mobile {
  display: none;
}

.nav-search img, .nav-user img {
  max-width: 18px;
}

.nav-search {
  display: block;
  z-index: 1;
  -webkit-user-select: none;
  user-select: none;
}

ul.submenu-list li a:hover {
  text-decoration: none;
}

#header {
  position: sticky;
  z-index: 999;
  height: max-content;
  top: 0;
}

.role-administrator #header {
  top: 79px;
}

.role-administrator #toolbar-administration {
  position: sticky;
  z-index: 99999999;
  height: max-content;
  top: 0;
}

.menu-buttons.desktop {
  display: flex;
  align-items: center;
}

.menu-buttons.desktop a:nth-child(2) {
  margin: 0 25px;
}

@media only screen and (max-width: 1460px) {
  .menu-buttons.desktop {
    width: 10%;
  }
}

@media only screen and (max-width: 1366px) {
  .brand {
    position: relative;
    top: -4px;
  }

  .menu-buttons.desktop {
    display: flex;
    width: auto;
  }
}

@media only screen and (max-width: 1200px) {
  .navbar .brand img {
    margin-left: 0;
    width: 130px;
    height: auto;
  }
}

@media only screen and (max-width: 1170px) {
  .brand {
    margin-left: -30px;
  }

  .menu-buttons.desktop a:nth-child(2) {
    margin: 0 15px;
  }

  .menu-buttons.desktop {
    margin-left: 00px;
  }

  .navbar-nav {
    margin-left: -10px;
  }
}

@media only screen and (max-width: 1050px) {
  .nav-item {
    margin-right: 7px;
  }
}

@media only screen and (max-width: 992px) {
  #menuToggle {
    right: 15px;
  }

  .toolbar-tray.toolbar-tray-vertical {
    width: 100%;
    background: none;
    overflow: scroll;
  }

  ul.toolbar-menu {
    display: flex;
    width: 100%;
  }

  #toolbar-bar {
    display: flex;
    overflow: scroll;
  }

  .nav-and-buttons {
    height: 100vh;
    overflow-y: scroll;
    background: #c4e4f9;
  }

  .dropdown-content .dropdown-menu.middle {
    width: auto;
  }

  li.nav-item.dropdown {
    margin: 0 15px;
  }

  .notification-menu-sidebar {
    left: -350px;
    right: inherit;
    z-index: 9999999999999;
  }

  .menu-buttons.mobile, .buttons-mobile-acc {
    background: #c4e4f9;

    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-top: -1px;
    width: 100%;
    max-width: 320px;
  }

  .buttons-mobile-acc .nav-user.new-cont {
    height: 45px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    background: #009FE3;
    border-radius: 50px;
    padding: 13px 23px;
  }


  .buttons-mobile-acc .nav-user.cont {
    height: 45px;
    color: #009FE3;
    border: 1px solid #009FE3;
    font-size: 14px;
    font-weight: 600;
    background: transparent;
    border-radius: 50px;
    padding: 13px 23px;
  }

  .hvr-grow {
    z-index: 1;
  }

  .hamburger {
    display: inline-block;
    cursor: pointer;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    overflow: visible;
  }

  .hamburger.is-active:hover {
    opacity: 1;
  }

  .hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: #17479E;
    opacity: 1;
  }

  .hamburger-box {
    width: 25px;
    height: 17px;
    display: inline-block;
    position: relative;
  }

  .hamburger-inner {
    display: block;
    top: 50%;
    margin-top: -2px;
  }

  .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    width: 25px;
    height: 2px;
    background-color: #17479E;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  .hamburger-inner::before, .hamburger-inner::after {
    content: "";
    display: block;
  }

  .hamburger-inner::before {
    top: -8px;
  }

  .hamburger-inner::after {
    bottom: -8px;
  }

  .hamburger--spin .hamburger-inner {
    transition-duration: 0.22s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin .hamburger-inner::before {
    transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
  }

  .hamburger--spin .hamburger-inner::after {
    transition: bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin.is-active .hamburger-inner {
    transform: rotate(225deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .hamburger--spin.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
  }

  .hamburger--spin.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
    transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .hamburger--spin-r .hamburger-inner {
    transition-duration: 0.22s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin-r .hamburger-inner::before {
    transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
  }

  .hamburger--spin-r .hamburger-inner::after {
    transition: bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin-r.is-active .hamburger-inner {
    transform: rotate(-225deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .hamburger--spin-r.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
  }

  .hamburger--spin-r.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(90deg);
    transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  .navbar-nav.nav {
    margin-left: 0;
  }

  .navbar {
    padding: 0;
  }

  ul#menu {
    background: #c4e4f9;
    width: 100%;

  }


  ul.submenu-list li a {
    margin: 0 16px 15px;
    color: #009FE3;

  }

  .nav-user.nav-user-mobile, .nav-user.nav-notification {
    display: block;
    position: absolute;
    top: 40px;
    -webkit-user-select: none;
    user-select: none;
    z-index: 999999;
  }

  #menuToggle {
    top: 31px;
    position: absolute;
  }

  .nav-search-mobile-h {
    position: absolute;
    right: 75px;
    top: 40px;
  }

  .nav-user.nav-user-mobile {
    left: 70px;
  }

  .nav-user.nav-notification {
    left: 55px;
  }

  .nav-user-mobile {
    position: absolute;
    left: 30px;
  }

  .nav-search-mobile {
    position: absolute;
    right: 45px;
  }

  .nav-user-mobile img, .nav-search-mobile img {
    max-width: 200px;

  }

  .nav-user-mobile img {
    top: -15px;
    position: relative;
  }


  .nav-search-mobile, .nav-user-mobile {
    display: block;
  }

  .nav-link {
    font-size: 16px;
    font-weight: 600;
    font-family: "Montserrat", sans-serif;
  }


  .nav {
    display: block;
  }

  .menu-buttons .align-center-mobile {
    justify-content: center;
  }

  .menu-buttons .dark-blue-button, .menu-buttons .no-border-blue-button {
    width: 50%;
    text-align: center;
    font-size: 12px;
  }

  .nav-item {
    display: flex;
    justify-content: center;
    font-size: 20px;
    flex-flow: column wrap;
    align-items: center;
  }

  .nav-and-buttons {
    display: none;
  }

  .triangle {
    display: none;
  }

  .dropdown-content .dropdown-menu {
    position: initial;
    width: auto;
    box-shadow: none;
    padding: 0;
    margin: 0;
    background: transparent;
    transform: inherit;
    display: none;
    text-align: center;
  }

  .dropdown-parent {
    position: relative;
    padding: 0 15px;
    width: 100%;
    justify-content: center;
  }

  .dropdown-parent i.fa-chevron-down {
    margin-left: 10px;
    margin-top: 2px;
  }

  .fa-close {
    transform: rotate(0deg);
    top: 17px;
  }

  .fa-open {
    transform: rotate(180deg);
  }

  .nav-item.dropdown {
    border-bottom: 1px solid #AAD3EF;
  }

  .dropdown-content .dropdown-menu {
    background: #fff;
    border-radius: 30px;
  }

  .dropdown-item, .submenu-list li a {
    color: #009FE3;
  }

  ul.submenu-list li {
    margin-bottom: 15px;
    font-weight: initial;
  }

  .dropdown-content .dropdown-menu.simple {
    padding: 30px 50px;
    width: auto;
  }

  .dropdown-item {
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    margin: 6px 0;
  }

  .fa-open, .fa-close {
    transition: all 0.3s ease-in;
  }

  .dropdown-item {
    padding-right: 0;
  }


  .navbar .container {
    justify-content: center;
  }

  .dropdown-content {
    position: initial;
    top: initial;
    padding-top: 0;
    width: 100%;

  }

  .menu-buttons.desktop {
    display: none;
  }

  .menu-buttons.mobile {
    display: block;
  }

  .brand {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0;
    //-webkit-box-shadow: 0 4px 15px 5px rgba(142, 142, 142, 0.99);
    //box-shadow: 0 4px 15px 5px rgba(142, 142, 142, 0.42);
  }
}

@media only screen and (max-width: 1400px) {
  .account-menu {
    padding-top: 40px !important;
  }
}

@media only screen and (max-width: 769px) {
  .brand {
    height: 70px;
    top: -16px;
  }

  .role-administrator #header {
    top: 0;
  }

  .toolbar .toolbar-tray-vertical .toolbar-menu a {
    padding-right: 0;
  }

  .toolbar .toolbar-icon.toolbar-handle {
    display: none;
  }

  .role-administrator .primary-nav {
    position: fixed;
    width: 100%;
    top: 79px;
  }

  body {
    padding: 0 !important;
  }

  .role-administrator .dialog-off-canvas-main-canvas {
    padding-top: 79px;
  }

  .toolbar .toolbar-bar {
    position: fixed;
  }

  .buttons-mobile-acc .nav-user.new-cont, .buttons-mobile-acc .nav-user.cont {
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .page-node-type-product .experts-products {
    margin-top: -230px !important;
  }

  .page-node-type-product .other-products .swiper-products {
    padding-bottom: 250px;
  }

  .other-products .swiper-button-next, .other-products .swiper-button-prev {
    top: 180px !important;
  }
}

@media only screen and (max-width: 576px) {
  .nav-item, .menu-buttons .dark-blue-button, .menu-buttons .no-border-blue-button {
    font-size: 16px;
  }

  .menu-buttons .dark-blue-button, .menu-buttons .no-border-blue-button {
    width: 48%;
    padding: 13px 15px;
    margin: 0;
  }

  .submenu-list {
    padding: 0;


  }
  .dropdown-item {
    padding: 10px 0;
  }

  .menu-buttons .dark-blue-button {
    margin-right: 5px;
  }
}

@media only screen and (max-width: 430px) {
  .dropdown-parent i.fa-chevron-down {
    right: 20%;
  }
}

@media only screen and (max-width: 340px) {
  .swiper-container.swiper-box.swiper-cereals {
    margin-right: -28px;
  }
}


</style>
